"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkScheduleSlotsHttpService = void 0;
const convert_work_schedule_slot_1 = require("../../types/work-schedule-slots/convert-work-schedule-slot");
const create_work_schedule_slot_1 = require("../../types/work-schedule-slots/create-work-schedule-slot");
const delete_by_id_1 = require("../../types/work-schedule-slots/delete-by-id");
const delete_occurence_1 = require("../../types/work-schedule-slots/delete-occurence");
const get_by_id_1 = require("../../types/work-schedule-slots/get-by-id");
const get_list_1 = require("../../types/work-schedule-slots/get-list");
const stop_recurrence_1 = require("../../types/work-schedule-slots/stop-recurrence");
const http_service_1 = require("../http.service");
class WorkScheduleSlotsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/work-schedule-slots`);
    }
    getList(payload) {
        const params = {
            ...payload,
            from: payload.from.toISOString(),
            to: payload.to.toISOString(),
        };
        return this.getEntityList('', {
            params,
            schema: get_list_1.getWorkScheduleSlotsListApiResponseSchema,
        });
    }
    getById(id) {
        return this.getEntity(id, {
            schema: get_by_id_1.getWorkScheduleSlotByIdApiResponseSchema,
        });
    }
    create(payload) {
        return this.postEntityList('', {
            body: payload,
            schema: create_work_schedule_slot_1.createWorkScheduleSlotApiResponseSchema,
        });
    }
    createBulk(payload) {
        return this.postEntityList('bulk', {
            body: payload,
            schema: create_work_schedule_slot_1.createWorkScheduleSlotApiResponseSchema,
        });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_by_id_1.deleteWorkScheduleSlotApiResponseSchema,
        });
    }
    deleteOccurrence(id, payload) {
        return this.postEntity(`${id}/delete-occurence`, {
            body: payload,
            schema: delete_occurence_1.deleteOccurrenceWorkScheduleSlotApiResponseSchema,
        });
    }
    stopRecurrence(id, payload) {
        return this.postEntityList(`${id}/stop-recurrence`, {
            body: payload,
            schema: stop_recurrence_1.stopRecurrenceWorkScheduleSlotApiResponseSchema,
        });
    }
    convert(id, payload) {
        return this.post(`${id}/convert`, {
            body: payload,
            schema: convert_work_schedule_slot_1.convertWorkScheduleSlotApiResponseSchema,
        });
    }
    updateTag(id, body) {
        return this.putEntity(`${id}/tag`, {
            body,
            schema: get_by_id_1.getWorkScheduleSlotByIdApiResponseSchema,
        });
    }
    updateAssistantMode(id, body) {
        const encodedId = encodeURIComponent(id);
        return this.putEntity(`${encodedId}/assistant-mode`, {
            body,
            schema: get_by_id_1.getWorkScheduleSlotByIdApiResponseSchema,
        });
    }
}
exports.WorkScheduleSlotsHttpService = WorkScheduleSlotsHttpService;
